'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('custom-entity-edit', {
      url: '/admin/custom-entity/edit',
      template: '<custom-entity-edit></custom-entity-edit>',
      authenticate: 'suite-admin'
    });
}



// WEBPACK FOOTER //
// ./client/app/admin/custom-entity-edit/custom-entity-edit.routes.js